var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"fixed_block",on:{"click":_vm.handleClick}},[_c('p',{staticClass:"title ellipsis2"},[_vm._v(_vm._s(_vm.infoData.noticeTitle))]),_c('i',{staticClass:"el-icon-close",on:{"click":function($event){$event.stopPropagation();_vm.isShow = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }